import 'jquery'

import 'tinymce/tinymce'

import 'tinymce/themes/silver/theme'

// Import TinyMCE
import tinymce from 'tinymce/tinymce'

//Import Icons since 5.3
import 'tinymce/icons/default' //https://stackoverflow.com/questions/20971537/tinymce-toolbar-icons-not-appearing

// A theme is also required
import 'tinymce/themes/silver'

// Any plugins you want to use has to be imported
import 'tinymce/plugins/code'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/link'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/template'
import 'tinymce/plugins/textcolor'

// tinymce languages
import 'tinymce-i18n/langs/ar'
import 'tinymce-i18n/langs/de'
import 'tinymce-i18n/langs/en_CA'

// vue2-datepicker theme
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/de'

import 'vue2-datepicker/locale/ar'

// require.context(
//  'file-loader?name=[path][name].[ext]&context=node_modules/tinymce!tinymce/skins',
//  true,
//  /.*/
// )

import marked from 'marked'

import moment from 'moment'
import 'moment/locale/ar'
import 'moment/locale/de'

moment.locale()

moment.updateLocale('en', {
  // use settings from singapore (especially 24 hour format instead of am/pm)
  longDateFormat: {
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
  },
  week: {
    // https://momentjs.com/docs/#/customization/dow-doy/
    dow: 1,
    doy: 4,
  },
})

// import vue
import { merge } from 'lodash'
import PortalVue from 'portal-vue'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueMoment from 'vue-moment'
import apolloProvider from './apollo-provider'
import App from './App.vue'
//import localeAR from './locales/ar_interview-report.yml'
//import localeDE from './locales/de_interview-report.yml'
//import localeEN from './locales/en_interview-report.yml'
//import translations from './locales/translations.yml'
import router from './routing'
import store from './store'

Vue.filter('calendarTime', (date: Date | string, locale: string | undefined): string => {
  return moment(date)
    .locale(locale || store.getters.currentLocale)
    .calendar()
})

Vue.filter('fromNow', (date: Date | string, locale: string | undefined): string => {
  return moment(date)
    .locale(locale || store.getters.currentLocale)
    .fromNow()
})

Vue.filter('shortUuid', (uuid: string): string => {
  return `${uuid.substring(2, 7)}...${uuid.substring(uuid.length - 2, uuid.length)}`
})

Vue.use(VueMoment)

Vue.filter(
  'formatDate',
  (date: Date | string, formatString = 'LLL', locale: string | undefined): string => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const formatted = moment(date)
      .locale(locale || store.getters.currentLocale)
      .format(formatString)
    if (timezone.toLowerCase() === 'utc') {
      return `${formatted} (UTC)`
    } else {
      return formatted
    }
  }
)

Vue.filter('renderMarkdown', (code: string) => marked(code))

Vue.filter(
  'translate',
  (byLanguage: object, toLanguage?: string) => byLanguage[toLanguage || store.getters.currentLocale]
)

Vue.mixin({
  methods: {
    consoleLog(...args) {
      console.log(...args)
    },
  },
})

Vue.config.productionTip = false

Vue.use(VueI18n)

Vue.use(PortalVue)
useStoredAuthToken()

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import VueApollo from 'vue-apollo'
Vue.use(VueApollo)

/*
let currentLocale: string = localStorage.getItem('currentLocale') || navigator.language || 'ar'
if (!['de', 'ar'].includes(currentLocale)) {
  currentLocale = 'ar'
}
*/
const currentLocale = localStorage.getItem('currentLocale') || 'ar'
localStorage.setItem('currentLocale', currentLocale)

const i18n = new VueI18n({
  locale: currentLocale,
  messages: merge(require('./locales/translations.yml'), {
    ar: require('./locales/ar_interview-report.yml'),
    de: require('./locales/de_interview-report.yml'),
    en: require('./locales/en_interview-report.yml'),
  }),
})

new Vue({
  apolloProvider,
  render: h => h(App),
  router,
  i18n,
  store,
  watch: {
    '$i18n.locale'(value: string) {
      store.commit({ type: 'changeLocale', locale: value })
      localStorage.setItem('currentLocale', value)
    },
  },
}).$mount('#app')

function useStoredAuthToken() {
  const authToken =
    window.sessionStorage.getItem('authToken') || window.localStorage.getItem('authToken')

  if (authToken !== null) {
    ;(Vue as any).http.headers.common.Authorization = `Bearer ${authToken}`
  }
}
